export enum ServiceJobViewType {
  Calendar = "calendar",
  Gantt = "gantt",
  Table = "table",
}
